// extracted by mini-css-extract-plugin
export default {"avatar":"Style_avatar__OquhB"};